module.exports = __webpack_public_path__ + "media/packs/images/flags/SN-17d4d9d1753783ed5489caf831f0e35d.png";